export const themePageCompanyAnaly = {
    title:
        '比較する企業を最大5社まで選択してください。選択した企業が属しているクラスタが表示され、スコア等を比較することができます。',
    metric: '表示データ',
    select1: 'スコア',
    select2: '特許出願数',
    select3: '被引用数（平均値）',
    select4: '重要特許数',
    select5: '重要特許率',
    companyPlaceholder: '企業を英語で入力してください',
    companyName: '企業を選択',
    tableColumn1: 'クラスタID',
    tableColumn2: 'クラスタ名',
    noDataMsg: '該当企業はこのクラスタのデータがありません'
}
